import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'
import { requiredIf } from '../../../../utility/prop-types-helper'
import GenderBreakdownPie from '../../../common/GenderBreakdownPie/GenderBreakdownPie'
import Loader from '../../../common/loader/Loader'

import classes from './StatsPanel.module.scss'

const StudentInformationWidget = ({ isLoading, studentsInfo }) => {
  const { t } = useTranslation()
  const withStudents = studentsInfo?.totalStudents > 0

  if (isLoading) {
    return (
      <section className={classnames('mt-3 d-flex align-items-center justify-content-center', classes.infoSection)}>
        <Loader>{t('programs.manage.studentInfo.loadingBusinessSummary')}</Loader>
      </section>
    )
  }

  return (
    <section className={classnames('mt-3 p-3 d-flex flex-column', classes.infoSection)}>
      <h3 className={classnames('mb-3', classes.title)}>{t('programs.manage.studentInfo.title')}</h3>
      <span className={classes.subtitle}>{t('programs.manage.studentInfo.ageRange')}</span>
      <span className={classes.title}>
        {withStudents
          ? t('programs.manage.studentInfo.ageRangeValue', {
            min: studentsInfo?.minimumAge,
            max: studentsInfo?.maximumAge,
          })
          : '----'}
      </span>
      <div className='flex-grow-1 flex-shrink-0 min-h-0'>
        <GenderBreakdownPie
          male={studentsInfo?.maleStudents}
          female={studentsInfo?.femaleStudents}
          other={studentsInfo?.otherStudents}
        />
      </div>
      <div className={classnames('my-3 d-flex justify-content-between', classes.statsItem)}>
        <span>{t('programs.manage.studentInfo.averageAge')}</span>
        <span>
          {withStudents ? studentsInfo?.averageAge : '---'}
        </span>
      </div>
      <div className={classnames('mb-3 d-flex justify-content-between', classes.statsItem)}>
        <span>{t('programs.manage.studentInfo.skillLevelRange')}</span>
        <span>
          {withStudents ? `L${studentsInfo?.minimumDivisionLevel} - L${studentsInfo?.maximumDivisionLevel}` : '---'}
        </span>
      </div>
    </section>
  )
}

StudentInformationWidget.propTypes = {
  isLoading: PropTypes.bool,
  studentsInfo: requiredIf(PropTypes.object, ({ isLoading }) => !isLoading),
}

export default StudentInformationWidget
